module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-plan-subscriber"
  }, [_vm._v(" Add a subscription (Client " + _vm._s(_vm.client_id) + "):"), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column large-4 align-right"
  }, [_c('label', [_vm._v("Also show unavailables  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unavailable),
      expression: "unavailable"
    }],
    attrs: {
      "type": "checkbox",
      "checked": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.unavailable) ? _vm._i(_vm.unavailable, null) > -1 : (_vm.unavailable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.unavailable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.unavailable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.unavailable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.unavailable = $$c
        }
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_plan),
      expression: "selected_plan"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected_plan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getPlans()), function(plan, index) {
    return _c('option', {
      domProps: {
        "value": plan.id
      }
    }, [_vm._v(_vm._s(plan.name))])
  }), 0)]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Free subscription"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.free_subscription),
      expression: "free_subscription"
    }],
    attrs: {
      "type": "checkbox",
      "checked": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.free_subscription) ? _vm._i(_vm.free_subscription, null) > -1 : (_vm.free_subscription)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.free_subscription,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.free_subscription = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.free_subscription = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.free_subscription = $$c
        }
      }
    }
  })]), _c('label', [_vm._v("Subscribe main driver"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribe_main_driver),
      expression: "subscribe_main_driver"
    }],
    attrs: {
      "type": "checkbox",
      "checked": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.subscribe_main_driver) ? _vm._i(_vm.subscribe_main_driver, null) > -1 : (_vm.subscribe_main_driver)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.subscribe_main_driver,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.subscribe_main_driver = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.subscribe_main_driver = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.subscribe_main_driver = $$c
        }
      }
    }
  })])])]), _c('ActionButton', {
    attrs: {
      "action": _vm.subscribe
    }
  }, [_vm._v("Subscribe")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c0a392da!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/ClientPlanSubscriber.vue
// module id = 2515
// module chunks = 1